import { Entity, Field } from "typegraph";
import IdName from "../IdName";
import { iDef } from "../TypeUtils";

export type Institution = (IdName & {guid:string});

@Entity({one: "userCurrent"})
export class TokenUser {

	@Field()
	private id: number;

	@Field()
	public firstName: string;

	@Field()
	public lastName: string;

	@Field()
	public email: string;

	@Field()
	public createDate: string;

	@Field()
	public locale: string;

	@Field({entity: IdName})
	private roles: IdName[];

	@Field({entity: IdName})
	private groups: IdName[];

	private lastLoginDate: Date;


	private institutions: Institution[];

	public constructor() {
		this.roles = [];
		this.groups = [];
		this.institutions = [];
	}

	public getId(): number {
		return this.id;
	}

	// TODO all this stuff should be done at least at  the gql resolver level
	public getName(): string {
		return this.firstName + " " + this.lastName;
	}

	public getRoles(): string[] {
		return this.roles ? this.roles.map((r) => r.name) : [];
	}

	public addRoles(...roles: IdName[])  {
		this.roles.push(...roles);
	}

	public getGroups(): string[] {
		return this.groups ? this.groups.map((g) => g.name) : [];
	}

	public addGroups(...groups: IdName[]) {
		this.groups.push(...groups);
	}

	public getInstitutions(): Institution[] {
		return this.institutions ? [...this.institutions] : [];
	}

	public addInstitutions(...institutions: Institution[]) {
		if(!this.institutions){
			this.institutions=[];
		}
		this.institutions.push(...institutions);
	}

	public getLastLoginDate():Date{
		//return new Date('2022-11-12')
		return this.lastLoginDate;
	}

}



// WEBPACK FOOTER //
// ./src/core/util/session/TokenUser.ts